import { customAlphabet } from "nanoid";
import { nolookalikesSafe } from "nanoid-dictionary";
import React, { ReactNode } from "react";
import { FetchProviderProps, Provider } from "use-http";

import { attemptSessionRefresh } from "api/sessionRefresh/refresh";
import { shouldRefreshAccessToken } from "api/sessionRefresh/storage";
import { getIsLoggingOut } from "api/utils";

interface ProviderFetchProps {
  children: ReactNode;
}

/**
 * Provides shared use-http request behavior for legacy Reef fetch callers.
 */
export function ProviderFetch({ children }: ProviderFetchProps) {
  const optionsConfig: FetchProviderProps["options"] = {
    interceptors: {
      request: async ({ options }) => {
        const requestStartedAt = Date.now();
        if (!getIsLoggingOut() && shouldRefreshAccessToken(requestStartedAt)) {
          await attemptSessionRefresh(requestStartedAt);
        }

        const generateId = customAlphabet(nolookalikesSafe);
        return {
          ...options, // returning the `options` is important
          headers: {
            ...options.headers,
            "X-Request-Id": `req_${generateId()}`,
          },
        };
      },
    },
  };

  return <Provider options={optionsConfig}>{children}</Provider>;
}
